const SurgoryData =[
    {
       "surgeonName":'Dr. karan Sharma',
       "one":3,
       "two":4,
       "three":0,
       "four":9,
       "five":6,
       "six":7,
       "seven":0,
       "eight":7,
       "nine":0,
       "ten":3,
       "eleven":5,
       "twelve":6,
       "thirteen":7,
       "fourteen":1,
       "fifteen":4,
       "sixteen":6,
       "seventeen":0,
       "eighteen":4,
       "nineteen":5,
       "twenty":5,
       "twentyone":9,
       "twentytwo":11,
       "twentythree":12,
       "twentyfour":0,
       "twentyfive":4,
       "twentysix":7,
       "twentyseven":6,
       "twentyeight":20,
       "twentynine":23,
       "thirty":3,
       "thirtyone":8,
       "total":230
    },
    {
        "surgeonName":'Dr. Raj kumar',
        "one":3,
        "two":4,
        "three":0,
        "four":9,
        "five":6,
        "six":7,
        "seven":0,
        "eight":7,
        "nine":0,
        "ten":3,
        "eleven":5,
        "twelve":6,
        "thirteen":7,
        "fourteen":1,
        "fifteen":4,
        "sixteen":6,
        "seventeen":0,
        "eighteen":4,
        "nineteen":5,
        "twenty":5,
        "twentyone":9,
        "twentytwo":11,
        "twentythree":12,
        "twentyfour":0,
        "twentyfive":4,
        "twentysix":7,
        "twentyseven":6,
        "twentyeight":20,
        "twentynine":23,
        "thirty":3,
        "thirtyone":8,
        "total":210
     },
  
     {
        "surgeonName":'Dr. Rohit shan',
        "one":3,
        "two":4,
        "three":0,
        "four":9,
        "five":6,
        "six":7,
        "seven":0,
        "eight":7,
        "nine":0,
        "ten":3,
        "eleven":5,
        "twelve":6,
        "thirteen":7,
        "fourteen":1,
        "fifteen":4,
        "sixteen":6,
        "seventeen":0,
        "eighteen":4,
        "nineteen":5,
        "twenty":5,
        "twentyone":9,
        "twentytwo":11,
        "twentythree":12,
        "twentyfour":0,
        "twentyfive":4,
        "twentysix":7,
        "twentyseven":6,
        "twentyeight":20,
        "twentynine":23,
        "thirty":3,
        "thirtyone":8,
        "total":200
     },
     {
        "surgeonName":'Dr. David Mashi',
        "one":3,
        "two":4,
        "three":0,
        "four":9,
        "five":6,
        "six":7,
        "seven":0,
        "eight":7,
        "nine":0,
        "ten":3,
        "eleven":5,
        "twelve":6,
        "thirteen":7,
        "fourteen":1,
        "fifteen":4,
        "sixteen":6,
        "seventeen":0,
        "eighteen":4,
        "nineteen":5,
        "twenty":5,
        "twentyone":9,
        "twentytwo":11,
        "twentythree":12,
        "twentyfour":0,
        "twentyfive":4,
        "twentysix":7,
        "twentyseven":6,
        "twentyeight":20,
        "twentynine":23,
        "thirty":3,
        "thirtyone":8,
        "total":180
     },
     {
        "surgeonName":'Dr. Aanad Rajan',
        "one":3,
        "two":4,
        "three":0,
        "four":9,
        "five":6,
        "six":7,
        "seven":0,
        "eight":7,
        "nine":0,
        "ten":3,
        "eleven":5,
        "twelve":6,
        "thirteen":7,
        "fourteen":1,
        "fifteen":4,
        "sixteen":6,
        "seventeen":0,
        "eighteen":4,
        "nineteen":5,
        "twenty":5,
        "twentyone":9,
        "twentytwo":11,
        "twentythree":12,
        "twentyfour":0,
        "twentyfive":4,
        "twentysix":7,
        "twentyseven":6,
        "twentyeight":20,
        "twentynine":23,
        "thirty":3,
        "thirtyone":8,
        "total":250
     },
     {
        "surgeonName":'Dr. Jasan Holder',
        "one":3,
        "two":4,
        "three":0,
        "four":9,
        "five":6,
        "six":7,
        "seven":0,
        "eight":7,
        "nine":0,
        "ten":3,
        "eleven":5,
        "twelve":6,
        "thirteen":7,
        "fourteen":1,
        "fifteen":4,
        "sixteen":6,
        "seventeen":0,
        "eighteen":4,
        "nineteen":5,
        "twenty":5,
        "twentyone":9,
        "twentytwo":11,
        "twentythree":12,
        "twentyfour":0,
        "twentyfive":4,
        "twentysix":7,
        "twentyseven":6,
        "twentyeight":20,
        "twentynine":23,
        "thirty":3,
        "thirtyone":8,
        "total":245
     },
  
  
  
  
 
]


const OperationData =[
   {
      "opType":'Accentrix',
      "one":3,
      "two":4,
      "three":0,
      "four":9,
      "five":6,
      "six":7,
      "seven":0,
      "eight":7,
      "nine":0,
      "ten":3,
      "eleven":5,
      "twelve":6,
      "thirteen":7,
      "fourteen":1,
      "fifteen":4,
      "sixteen":6,
      "seventeen":0,
      "eighteen":4,
      "nineteen":5,
      "twenty":5,
      "twentyone":9,
      "twentytwo":11,
      "twentythree":12,
      "twentyfour":0,
      "twentyfive":4,
      "twentysix":7,
      "twentyseven":6,
      "twentyeight":20,
      "twentynine":23,
      "thirty":3,
      "thirtyone":8,
      "total":230
   },
   {
       "opType":'Avastin',
       "one":3,
       "two":4,
       "three":0,
       "four":9,
       "five":6,
       "six":7,
       "seven":0,
       "eight":7,
       "nine":0,
       "ten":3,
       "eleven":5,
       "twelve":6,
       "thirteen":7,
       "fourteen":1,
       "fifteen":4,
       "sixteen":6,
       "seventeen":0,
       "eighteen":4,
       "nineteen":5,
       "twenty":5,
       "twentyone":9,
       "twentytwo":11,
       "twentythree":12,
       "twentyfour":0,
       "twentyfive":4,
       "twentysix":7,
       "twentyseven":6,
       "twentyeight":20,
       "twentynine":23,
       "thirty":3,
       "thirtyone":8,
       "total":210
    },
 
    {
       "opType":'Cataract',
       "one":3,
       "two":4,
       "three":0,
       "four":9,
       "five":6,
       "six":7,
       "seven":0,
       "eight":7,
       "nine":0,
       "ten":3,
       "eleven":5,
       "twelve":6,
       "thirteen":7,
       "fourteen":1,
       "fifteen":4,
       "sixteen":6,
       "seventeen":0,
       "eighteen":4,
       "nineteen":5,
       "twenty":5,
       "twentyone":9,
       "twentytwo":11,
       "twentythree":12,
       "twentyfour":0,
       "twentyfive":4,
       "twentysix":7,
       "twentyseven":6,
       "twentyeight":20,
       "twentynine":23,
       "thirty":3,
       "thirtyone":8,
       "total":200
    },
    {
       "opType":'Cataract+Trab',
       "one":3,
       "two":4,
       "three":0,
       "four":9,
       "five":6,
       "six":7,
       "seven":0,
       "eight":7,
       "nine":0,
       "ten":3,
       "eleven":5,
       "twelve":6,
       "thirteen":7,
       "fourteen":1,
       "fifteen":4,
       "sixteen":6,
       "seventeen":0,
       "eighteen":4,
       "nineteen":5,
       "twenty":5,
       "twentyone":9,
       "twentytwo":11,
       "twentythree":12,
       "twentyfour":0,
       "twentyfive":4,
       "twentysix":7,
       "twentyseven":6,
       "twentyeight":20,
       "twentynine":23,
       "thirty":3,
       "thirtyone":8,
       "total":180
    },
    {
       "opType":'Cataract+VitrectoMy',
       "one":3,
       "two":4,
       "three":0,
       "four":9,
       "five":6,
       "six":7,
       "seven":0,
       "eight":7,
       "nine":0,
       "ten":3,
       "eleven":5,
       "twelve":6,
       "thirteen":7,
       "fourteen":1,
       "fifteen":4,
       "sixteen":6,
       "seventeen":0,
       "eighteen":4,
       "nineteen":5,
       "twenty":5,
       "twentyone":9,
       "twentytwo":11,
       "twentythree":12,
       "twentyfour":0,
       "twentyfive":4,
       "twentysix":7,
       "twentyseven":6,
       "twentyeight":20,
       "twentynine":23,
       "thirty":3,
       "thirtyone":8,
       "total":250
    },
    {
       "opType":'Cornea',
       "one":3,
       "two":4,
       "three":0,
       "four":9,
       "five":6,
       "six":7,
       "seven":0,
       "eight":7,
       "nine":0,
       "ten":3,
       "eleven":5,
       "twelve":6,
       "thirteen":7,
       "fourteen":1,
       "fifteen":4,
       "sixteen":6,
       "seventeen":0,
       "eighteen":4,
       "nineteen":5,
       "twenty":5,
       "twentyone":9,
       "twentytwo":11,
       "twentythree":12,
       "twentyfour":0,
       "twentyfive":4,
       "twentysix":7,
       "twentyseven":6,
       "twentyeight":20,
       "twentynine":23,
       "thirty":3,
       "thirtyone":8,
       "total":245
    },
    {
      "opType":'Eylea',
      "one":3,
      "two":4,
      "three":0,
      "four":9,
      "five":6,
      "six":7,
      "seven":0,
      "eight":7,
      "nine":0,
      "ten":3,
      "eleven":5,
      "twelve":6,
      "thirteen":7,
      "fourteen":1,
      "fifteen":4,
      "sixteen":6,
      "seventeen":0,
      "eighteen":4,
      "nineteen":5,
      "twenty":5,
      "twentyone":9,
      "twentytwo":11,
      "twentythree":12,
      "twentyfour":0,
      "twentyfive":4,
      "twentysix":7,
      "twentyseven":6,
      "twentyeight":20,
      "twentynine":23,
      "thirty":3,
      "thirtyone":8,
      "total":245
   },

   {
      "opType":'General',
      "one":3,
      "two":4,
      "three":0,
      "four":9,
      "five":6,
      "six":7,
      "seven":0,
      "eight":7,
      "nine":0,
      "ten":3,
      "eleven":5,
      "twelve":6,
      "thirteen":7,
      "fourteen":1,
      "fifteen":4,
      "sixteen":6,
      "seventeen":0,
      "eighteen":4,
      "nineteen":5,
      "twenty":5,
      "twentyone":9,
      "twentytwo":11,
      "twentythree":12,
      "twentyfour":0,
      "twentyfive":4,
      "twentysix":7,
      "twentyseven":6,
      "twentyeight":20,
      "twentynine":23,
      "thirty":3,
      "thirtyone":8,
      "total":245
   },

 
 
 
 

]


const SurgeonSummeryData =[
    { 
      "surgeonName":'Dr. Jasan Holder',
      "total":7,
      "contribution":"10.02%",
      "male":3,
      "female":4,
     },
     { 
      "surgeonName":'Dr. Rohit Sharma',
      "total":22,
      "contribution":"12.22%",
      "male":14,
      "female":8,
     },
     { 
      "surgeonName":'Dr. Raj Kumar',
      "total":32,
      "contribution":"80.02%",
      "male":20,
      "female":12,
     },
     { 
      "surgeonName":'Dr. Pawan Patidar',
      "total":12,
      "contribution":"70.02%",
      "male":8,
      "female":4,
     },
     { 
      "surgeonName":'Dr. Kunam Khandelwal',
      "total":22,
      "contribution":"60.72%",
      "male":14,
      "female":8,
     },
     { 
      "surgeonName":'Dr. Aanad Kumar',
      "total":27,
      "contribution":"85.23%",
      "male":15,
      "female":12,
     },
     { 
      "surgeonName":'Dr.Hemant Rathore',
      "total":60,
      "contribution":"77.45%",
      "male":35,
      "female":25,
     }
]



const OperationSummeryData =[
   { 
    "opType":'Accentrix',
     "total":7,
     "contribution":"10.02%",
     "male":3,
     "female":4,
    },
    { 
      "opType":'Avastin',
     "total":22,
     "contribution":"12.22%",
     "male":14,
     "female":8,
    },
    { 
     "opType":'Cataract',
     "total":32,
     "contribution":"80.02%",
     "male":20,
     "female":12,
    },
    { 
     "opType":'Cataract+Trab',
     "total":12,
     "contribution":"70.02%",
     "male":8,
     "female":4,
    },
    { 
      "opType":'Cornea',
     "total":22,
     "contribution":"60.72%",
     "male":14,
     "female":8,
    },
    { 
      "opType":'Eylea',
     "total":27,
     "contribution":"85.23%",
     "male":15,
     "female":12,
    },
    { 
      "opType":'General',
     "total":60,
     "contribution":"77.45%",
     "male":35,
     "female":25,
    }
]


export { SurgoryData }
export { OperationData }
export { SurgeonSummeryData}
export { OperationSummeryData}